import * as i18next from "i18next"
import { initReactI18next } from "react-i18next"

import daTranslation from "./locales/da.json"
import deTranslation from "./locales/de.json"
import enTranslation from "./locales/en.json"
import nbTranslation from "./locales/nb.json"
import svTranslation from "./locales/sv.json"

const i18n = i18next.createInstance()

export const initI18n = (locale: string = "sv-SE") => {
  i18n.use(initReactI18next).init({
    lng: locale,
    fallbackLng: "sv-SE",
    load: "languageOnly",
    showSupportNotice: false,
    resources: {
      sv: {
        translation: svTranslation,
      },
      en: {
        translation: enTranslation,
      },
      nb: {
        translation: nbTranslation,
      },
      da: {
        translation: daTranslation,
      },
      de: {
        translation: deTranslation,
      },
    },
    interpolation: {
      escapeValue: false,
    },
  })

  return i18n
}

export default i18n
